const translations = {
  PT: {
    senha: 'Senha',
    login: 'Iniciar Sessão',
    registrar: 'Registar',
    esqueciSenha: 'Esqueci minha senha',
    jaTemConta: 'Já tem conta? Faça login',
    msgEsqueceuSenha: 'Esqueceu sua senha? Informe seu e-mail para solicitar a recuperação de senha!',
    msgEmailToken: 'Foi enviado um token de validação para seu e-mail.',
    validar: 'Validar',
    nome: 'Nome',
    vazio: 'Nenhum dado a ser exibido',
    filtro: 'Procurar',
    sair: 'Sair',
    alterarMeusDados: 'Alterar meus dados',
    confirmaExclusao: 'Tem certeza que deseja realizar a exclusão/ativação deste registro?',
  },
  EN: {
    senha: 'Password',
    login: 'Login',
    registrar: "New User",
    esqueciSenha: 'I forgot my password',
    jaTemConta: 'Already have an account? Log in',
    msgEsqueceuSenha: 'Forgot your password? Enter your email to request a password reset!',
    msgEmailToken: 'A validation token has been sent to your email.',
    validar: 'Validate',
    nome: 'Name',
    vazio: 'No data to display',
    filtro: 'Secarch',
    sair: 'Logout',
    alterarMeusDados: 'Change my information',
    confirmaExclusao: 'Are you sure you want to delete/activate this record?',
  },
};

export default translations;
